import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { CaptionLG } from '@/atoms/Text'
import {
  PackCartProduct,
  useCollectiblesPurchaseContext,
} from '@/contexts/CollectiblesPurchaseContext/CollectiblesPurchaseContextProvider'
import { formatPrice } from '@/services/PriceFormatter'

interface Props {
  packs: PackCartProduct[] | undefined
}

export const PacksPurchaseDescription: React.FC<Props> = ({ packs }) => {
  if (!packs) return

  return (
    <div className="max-h-[500px] overflow-y-auto">
      {packs.map((packs, index) => {
        return (
          <div key={index} className="relative mt-5 flex flex-row gap-3 text-left">
            <div className="min-w-[160px] w-40 lg:min-w-[240px] lg:w-60">
              <div className="aspect-h-8 aspect-w-16 relative my-1">
                <Image
                  src={packs.image}
                  alt={packs.name || 'Moment frame'}
                  fill={true}
                  className={classNames('cursor-pointer outline-4 outline-transparent object-cover z-0')}
                />
              </div>
            </div>
            <div className="flex justify-evenly flex-col">
              <CaptionLG className="text-base font-[600]">{packs.name}</CaptionLG>
              <CaptionLG className="text-base font-[600]">
                {formatPrice(packs.price, { currency: 'USD', ignoreEmptyDecimal: true })}
              </CaptionLG>
            </div>
          </div>
        )
      })}
    </div>
  )
}
